import EmployeeLocationListLeft from '@/components/communication/EmployeeLocations/EmployeeLocationList/EmployeeLocationListLeft/EmployeeLocationListLeft';
import EmployeeLocationListRight from '@/components/communication/EmployeeLocations/EmployeeLocationList/EmployeeLocationListRight/EmployeeLocationListRight';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { InputText } from 'primereact/inputtext';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class EmployeeLocationList extends Component {
  renderLeftColumnInputs = () => {
    const { departmentSearchText, teamSearchText, updateSearchTextChange } = this.props;

    return (
      <div className="search-inputs-left">
        <div className="search-input-wrapper">
          <img
            src="/assets/img/search-icon.svg"
            alt="Search"
            className="search-icon"
          />
          <InputText
            type="text"
            placeholder="部署"
            value={departmentSearchText}
            onChange={e => updateSearchTextChange({ value: e.target.value, type: 'department' })}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper">
          <img
            src="/assets/img/search-icon.svg"
            alt="Search"
            className="search-icon"
          />
          <InputText
            type="text"
            placeholder="チーム"
            value={teamSearchText}
            onChange={e => updateSearchTextChange({ value: e.target.value, type: 'team' })}
            className="search-input"
          />
        </div>
      </div>
    );
  };

  renderRightColumnInputs = () => {
    const { employeeSearchText, updateSearchTextChange } = this.props;

    return (
      <div className="search-inputs-right">
        <div className="search-input-wrapper search-input-large">
          <img
            src="/assets/img/search-icon.svg"
            alt="Search"
            className="search-icon"
          />
          <InputText
            type="text"
            placeholder="検索"
            value={employeeSearchText}
            onChange={e => updateSearchTextChange({ value: e.target.value, type: 'employee' })}
            className="search-input"
          />
        </div>
      </div>
    );
  };

  renderSearchInputs = () => {
    const { departmentSearchText, teamSearchText, employeeSearchText, updateSearchTextChange } = this.props;

    return (
      <div className="search-inputs-container">
        <div className="search-input-wrapper">
          <img
            src="/assets/img/search-icon.svg"
            alt="Search"
            className="search-icon"
          />
          <InputText
            type="text"
            placeholder="部署"
            value={departmentSearchText}
            onChange={e => updateSearchTextChange({ value: e.target.value, type: 'department' })}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper">
          <img
            src="/assets/img/search-icon.svg"
            alt="Search"
            className="search-icon"
          />
          <InputText
            type="text"
            placeholder="チーム"
            value={teamSearchText}
            onChange={e => updateSearchTextChange({ value: e.target.value, type: 'team' })}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper search-input-large">
          <img
            src="/assets/img/search-icon.svg"
            alt="Search"
            className="search-icon"
          />
          <InputText
            type="text"
            placeholder="検索"
            value={employeeSearchText}
            onChange={e => updateSearchTextChange({ value: e.target.value, type: 'employee' })}
            className="search-input"
          />
        </div>
      </div>
    );
  };

  render() {
    const {
      isLoading,
      departmentList,
      empLocGroupedByTeam,
      selectKeyTeam,
      departmentActiveIndex,
      otherDepartmentActiveIndex,
      departmentSearchText,
      teamSearchText,
      employeeSearchText,
      branchName,
      filteredEmpLocGroupedByDeptAndTeam,
      totalEmployeeMap,
      allEmployees,
      followedEmployeeIds,
      onFollowChange,
      updateSearchTextChange,
      updateSelectKeyTeam,
      updateActiveIndex,
      renderMode,
    } = this.props;

    // For unified mode, render both left and right components in a 2-column layout
    if (renderMode === 'unified') {
      return (
        <div className="employee-location-list-container">
          <div className="list-content-wrapper">
            <div className="component-container left-column">
              {this.renderLeftColumnInputs()}
              <EmployeeLocationListLeft
                isLoading={isLoading}
                departmentList={departmentList}
                departmentActiveIndex={departmentActiveIndex}
                otherDepartmentActiveIndex={otherDepartmentActiveIndex}
                selectKeyTeam={selectKeyTeam}
                filteredEmpLocGroupedByDeptAndTeam={
                  filteredEmpLocGroupedByDeptAndTeam
                }
                departmentSearchText={departmentSearchText}
                teamSearchText={teamSearchText}
                branchName={branchName}
                totalEmployeeMap={totalEmployeeMap}
                allEmployees={allEmployees}
                followedEmployeeIds={followedEmployeeIds}
                onFollowChange={onFollowChange}
                updateSearchTextChange={updateSearchTextChange}
                updateSelectKeyTeam={updateSelectKeyTeam}
                updateActiveIndex={updateActiveIndex}
              />
            </div>
            <div className="component-container right-column">
              {this.renderRightColumnInputs()}
              <EmployeeLocationListRight
                isLoading={isLoading}
                employeeSearchText={employeeSearchText}
                departmentSearchText={departmentSearchText}
                roomSearchText={teamSearchText}
                empLocGroupedByTeam={empLocGroupedByTeam}
                selectKeyTeam={selectKeyTeam}
                followedEmployeeIds={followedEmployeeIds}
                onFollowChange={onFollowChange}
                updateSearchTextChange={updateSearchTextChange}
                onRefresh={this.props.onRefresh}
                hideSearchInputs={true}
              />
            </div>
          </div>
        </div>
      );
    }

    // Legacy mode - render as before for backward compatibility
    return (
      <div className="employee-location-list-container">
        {this.renderSearchInputs()}
        <div className="list-content-wrapper">
          <div className="component-container">
            <EmployeeLocationListLeft
              isLoading={isLoading}
              departmentList={departmentList}
              departmentActiveIndex={departmentActiveIndex}
              otherDepartmentActiveIndex={otherDepartmentActiveIndex}
              selectKeyTeam={selectKeyTeam}
              filteredEmpLocGroupedByDeptAndTeam={
                filteredEmpLocGroupedByDeptAndTeam
              }
              departmentSearchText={departmentSearchText}
              teamSearchText={teamSearchText}
              branchName={branchName}
              totalEmployeeMap={totalEmployeeMap}
              allEmployees={allEmployees}
              followedEmployeeIds={followedEmployeeIds}
              onFollowChange={onFollowChange}
              updateSearchTextChange={updateSearchTextChange}
              updateSelectKeyTeam={updateSelectKeyTeam}
              updateActiveIndex={updateActiveIndex}
            />
          </div>
          <div className="component-container">
            <EmployeeLocationListRight
              isLoading={isLoading}
              employeeSearchText={employeeSearchText}
              departmentSearchText={departmentSearchText}
              roomSearchText={teamSearchText}
              empLocGroupedByTeam={empLocGroupedByTeam}
              selectKeyTeam={selectKeyTeam}
              followedEmployeeIds={followedEmployeeIds}
              onFollowChange={onFollowChange}
              updateSearchTextChange={updateSearchTextChange}
              onRefresh={this.props.onRefresh}
            />
          </div>
        </div>
      </div>
    );
  }
}

EmployeeLocationList.propTypes = {
  isLoading: PropTypes.bool,
  departmentList: PropTypes.array,
  empLocGroupedByTeam: PropTypes.array,
  selectKeyTeam: PropTypes.string,
  departmentActiveIndex: PropTypes.array,
  otherDepartmentActiveIndex: PropTypes.array,
  employeeSearchText: PropTypes.string,
  departmentSearchText: PropTypes.string,
  teamSearchText: PropTypes.string,
  branchName: PropTypes.string,
  filteredEmpLocGroupedByDeptAndTeam: PropTypes.object,
  totalEmployeeMap: PropTypes.object,
  allEmployees: PropTypes.array,
  followedEmployeeIds: PropTypes.instanceOf(Set),
  onFollowChange: PropTypes.func,

  updateSearchTextChange: PropTypes.func,
  updateSelectKeyTeam: PropTypes.func,
  updateActiveIndex: PropTypes.func,
  onRefresh: PropTypes.func,
  renderMode: PropTypes.string,
};

export default EmployeeLocationList;
